import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { MsAdalAngular6Module } from 'microsoft-adal-angular6';
import {
  NgxUiLoaderConfig,
  NgxUiLoaderHttpConfig,
  NgxUiLoaderHttpModule,
  NgxUiLoaderModule,
  NgxUiLoaderRouterModule
} from 'ngx-ui-loader';
import { AppErrorComponent } from './app-error/app-error.component';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: '#0e68aa',
  bgsOpacity: 0.5,
  bgsPosition: 'bottom-right',
  bgsSize: 70,
  bgsType: 'ball-scale-multiple',
  blur: 1,
  delay: 0,
  fastFadeOut: true,
  fgsColor: '#0e68aa',
  fgsPosition: 'center-center',
  fgsSize: 70,
  fgsType: 'ball-scale-multiple',
  gap: 24,
  logoPosition: 'center-center',
  logoSize: 120,
  logoUrl: '',
  masterLoaderId: 'master',
  overlayBorderRadius: '0',
  overlayColor: 'rgba(255,255,255,0.71)',
  pbColor: '#0e68aa',
  pbDirection: 'ltr',
  pbThickness: 3,
  hasProgressBar: true,
  text: '',
  textColor: '#FFFFFF',
  textPosition: 'center-center',
};

const ngxUiLoaderHttpConfig: NgxUiLoaderHttpConfig = {
  showForeground: false
};

@NgModule({
  declarations: [
    AppComponent,
    AppErrorComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MsAdalAngular6Module.forRoot({
      //angualr
      //tenant: '8a64d468-b9b4-49a0-ac5d-bc3a4df33d7b',
      //clientId: '002dc4cc-7724-46cc-83ac-0a3ae20be048',
      //coca-cola
      tenant: '548d26ab-8caa-49e1-97c2-a1b1a06cc39c',
      clientId: '69a8cec0-5b5f-415b-a985-f027faa8a2ed',
      redirectUri: window.location.origin,
      //navigateToLoginRequestUrl: true,
      cacheLocation: '<localStorage / sessionStorage>'
    }),
    CoreModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderRouterModule,
    NgxUiLoaderHttpModule.forRoot(ngxUiLoaderHttpConfig),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
